import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
} from '@angular/router';

import { filter } from 'rxjs';

import { AutorizacaoService } from './autorizacao.service';

export function autorizacaoAwaitGuard(): CanActivateFn {
  return (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const autorizacaoService = inject(AutorizacaoService);
    return autorizacaoService.autorizacoesCarregadas$.pipe(
      filter((autorizacaoCarregada) => autorizacaoCarregada)
    );
  };
}
